var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"noReturnShopHead"},[_c('div',{staticClass:"bottom-head"},[_c('el-row',{staticClass:"contain"},[_c('el-col',{attrs:{"span":22}},[_c('div',{staticClass:"head-logo"},[_c('img',{attrs:{"src":require("../../assets/img/logo7.png"),"alt":""}})])])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51b0a580","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/noReturnShopHead.vue
// module id = null
// module chunks = 